"use client";

import CTA from "@/components/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

const laptopTangerang: ReactNode = (
  <>
    <h2 className="text-xl font-bold mb-2">Kenapa Sewa Laptop di Tangerang Adalah Pilihan Cerdas?</h2>

    <h3 className="text-lg font-semibold mb-2">
      Di Tengah Pusat Industri, Sewa Laptop Tangerang Jadi Solusi Kerja Cepat
    </h3>

    <p className="mb-4">
      Kota Tangerang bukan sekadar kota penyangga ibu kota. Ini medan tempur bisnis, pabrik, logistik, dan pelatihan. Di tengah arus kebutuhan digital
      yang meledak², <strong>sewa laptop Tangerang</strong> hadir sebagai solusi gesit tanpa harus keluar banyak modal. Cukup sewa, unit datang, kerja langsung tancap gas.
    </p>

    <ul className="space-y-4 mb-6">
      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Area Layanan Super Luas di Tangerang</h4>
        <p className="text-sm">
          Kami hadir di tengah denyut kawasan strategis: <strong>Cikokol, Karawaci, Batuceper, Poris, Ciledug, Jatiuwung, Bitung, Cikupa hingga Balaraja</strong>. Semua bisa kami cover untuk kebutuhan <strong>sewa laptop Tangerang</strong>, dari kantor pusat hingga gudang terpencil.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Laptop Siap Pakai: Baru, Cepat, Anti Lemot</h4>
        <p className="text-sm">
          Tak perlu install ulang atau konfigurasi manual. Semua unit <strong>sewa laptop Tangerang</strong> sudah kami siapkan dengan OS terbaru, aplikasi kerja, hingga custom software bila dibutuhkan.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Gratis Ongkir + Prioritas Waktu</h4>
        <p className="text-sm">
          Untuk pengiriman ke <strong>Karawaci, Bitung, Jatiuwung, dan pusat kota Tangerang</strong>, kami gratiskan ongkir. Bahkan untuk beberapa titik industri tertentu, pengiriman kami prioritaskan agar bisa sampai dalam hitungan jam.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Dukungan Teknis Real-Time</h4>
        <p className="text-sm">
          Ketika laptop bermasalah saat tender atau pelatihan, tim kami standby. Proses <strong>sewa laptop Tangerang</strong> dilengkapi backup device dan tim maintenance onsite bila perlu. Tanpa delay.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Harga Nego, Spesifikasi Fleksibel</h4>
        <p className="text-sm">
          Perusahaan perlu 2 unit Core i5 RAM 8GB untuk audit? Atau startup butuh 20 unit Core i7 SSD buat event? Semua bisa. <strong>Sewa laptop Tangerang</strong> kami hadirkan fleksibilitas dalam harga, durasi, dan tipe. Makin lama sewa, makin miring harga.
        </p>
      </li>
    </ul>

    <h2 className="text-xl font-bold mb-3">Antar Jemput Cepat, Hemat Waktu Produksi</h2>
    <p className="mb-4">
      Waktu adalah sumber daya paling mahal. <strong>Sewa laptop Tangerang</strong> kami antar jemput langsung ke lokasi. Tidak perlu pickup sendiri. Semua bisa diatur via WA.
    </p>

    <h2 className="text-xl font-bold mb-3">Durasi Sewa Laptop Tangerang Tanpa Batasan</h2>
    <p className="mb-4">
      Dari kebutuhan harian untuk booth event, mingguan untuk pelatihan SDM, hingga bulanan untuk proyek tender, kami support semua. <strong>Sewa laptop Tangerang</strong> bebas minimum durasi.
    </p>

    <h2 className="text-xl font-bold mb-3">Maintenance Berlapis Sepanjang Kontrak</h2>
    <p className="mb-4">
      Selama <strong>sewa laptop Tangerang</strong> berjalan, tim kami rutin cek kondisi, bantu troubleshoot, bahkan ganti unit bila perlu. Kamu cukup fokus kerja, sisanya kami yang urus.
    </p>

    <CTA
      title="Siap Kerja Editing & Olah Data Dimana² Bosku?"
      description="🚚 Butuh sewa laptop terdekat sekarang juga? Chat tim kami sekarang. <br />Kapan pun, di mana pun, selama unit ready, kami kirim hari itu juga."
      buttonText="Booking Laptop Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20laptop.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ category="Laptop" />
  </>
);

export default laptopTangerang;